import { statusLabel } from "./format";
import type { IParcel } from "./proto";

const MIN_PHONE_DIGITS = 4;

function phoneDigits(text: string): string {
  return text.replace(/\D/g, "").replace(/^(254|0)/, "");
}

export function matchesParcel(parcel: IParcel, query: string): boolean {
  const term = query.trim().toLowerCase();
  if (!term) return true;

  const typedDigits = phoneDigits(term);
  if (typedDigits.length >= MIN_PHONE_DIGITS && /^[\d\s+()-]+$/.test(term)) {
    if (phoneDigits(parcel.customerPhone ?? "").includes(typedDigits)) return true;
  }

  return [
    parcel.customerName,
    parcel.customerPhone,
    parcel.customerPpCode,
    parcel.trackingNumber,
    parcel.labelCode,
    parcel.description,
    parcel.deliveryArea,
    parcel.deliveryAddress,
    statusLabel(parcel.status),
  ].some((field) => field?.toLowerCase().includes(term));
}
